import { configureStore } from "@reduxjs/toolkit";
import spotsReducer from "../features/spots/spotsSlice";
import userReducer from "../features/user/userSlice";
import workPlacesReducer from "../features/workplaces/workPlacesSlice";

const store = configureStore({
  reducer: {
    spots: spotsReducer,
    workPlaces: workPlacesReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
